import {BusinessBadge, Button, Image, Lead, Radio, Slot, Text, Trail, Typography} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import type {FC} from 'react'

import {useAction} from '../../actions'
import {ActionType} from '../../actions/types'
import {tagToUrl} from '../../lib/tagToUrl'
import * as classes from './classes@desktop'

export const BusinessOfferSlot: FC = () => {
  const i18n = useI18n()
  const {ActionComponent, triggerAction} = useAction({type: ActionType.MODAL, modal_id: 'business'})

  return (
    <Slot size="l">
      <Lead
        // @ts-expect-error 😔 кривая типизация GWC, пропс наследуется вот Box
        justifyContent="initial"
        size="m"
      >
        <Image height={24} loading="lazy" src={tagToUrl('delivery_form_business_account')} width={36} />
      </Lead>
      <Text>
        <Typography group="tight" thickness="regular" variant="body2">
          {i18n('Расчётный счёт')}
          <BusinessBadge>{i18n('bdui.business-badge', 'Бизнес')}</BusinessBadge>
        </Typography>
        <Typography color="minor" group="tight" thickness="regular" variant="caption1">
          {i18n('Работайте по договору, получайте счета и акты')}
        </Typography>
      </Text>
      <Trail className={classes.trail}>
        <Button onPress={triggerAction} shape="circle" size="xs" variant="outline">
          {i18n('Подробнее')}
        </Button>
      </Trail>
      <Trail ml="s">
        <Radio onClick={triggerAction} />
      </Trail>
      {ActionComponent}
    </Slot>
  )
}
